import React from 'react';
import { NotificationItem as NotificationItemType } from '../notificationsTypes';
import { NotificationItemComponent } from './NotificationItem';
import styles from './NotificationList.module.css';

interface NotificationListProps {
  notifications: NotificationItemType[];
  onMarkAsRead?: (id: string) => void;
  emptyMessage?: string;
}

export const NotificationList: React.FC<NotificationListProps> = ({
  notifications,
  onMarkAsRead,
  emptyMessage = 'No notifications',
}) => {
  if (notifications.length === 0) {
    return (
      <div className={styles.empty}>
        <span className={styles.emptyIcon}>🔔</span>
        <p className={styles.emptyText}>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className={styles.list}>
      {notifications.map((notification) => (
        <NotificationItemComponent
          key={notification.id}
          notification={notification}
          onMarkAsRead={onMarkAsRead}
        />
      ))}
    </div>
  );
};
